import {Vector2} from './vector'
import {randIntRange} from './utils'
import {ctx, canvas}  from './world'



export const SpawnQiBalls = ()=>{
  let qiBalls = [];
  for(let i = 0; i < 1; i++) {
    let pos = new Vector2(canvas.width/2, canvas.height/2)
    for(let j = 0; j < 10; j++) {

      pos.add(new Vector2(-5, 5, -5, 5))
      setTimeout( ()=> {
        let qiBall = new QiBall(pos);
        qiBalls.push(qiBall)
      }, j * 100)
    }
    } 
    return qiBalls;
  }


// send ripple through the qi ball on beat.
// control beat from push
class QiBall {

    constructor( startingPos){
      let radius = 111;
        this.position = startingPos;
        this.spawnTime = performance.now()
        this.qiNodes = [];

        let numSegments = 22;
        let thetaStart = 0;
        let thetaLength = Math.PI * 2;
        for(let s = 0; s < numSegments; s ++) {
            let segment = thetaStart + s/numSegments * thetaLength;
            let position = new Vector2();
            position.x = this.position.x + radius * Math.cos(segment);
            position.y = this.position.y + radius * Math.sin(segment);

            let qiNode = new QiNode(position);

            if(s > 0 ){
                qiNode.addLink(this.qiNodes[ s-1]);
            }
            this.qiNodes.push(qiNode);
        }
        this.qiNodes[0].addLink(this.qiNodes[this.qiNodes.length-1])

        this.ripple();
    }

    onNote() {
        this.blast();
    }

    blast () {
        let centerPosition = this.position;
        this.qiNodes.forEach ((node) => {
            node.velocity = ()=> {
                return new Vector2().subVectors(node.position, centerPosition).multiplyScalar(.1);
            }
        });
    }

    ripple () {
        this.qiNodes.forEach ((node, index) => {
           
         let centerPosition = this.position;
          node.velocity = () => {
              let direction = new Vector2().subVectors(node.position, centerPosition);
              let velocity = direction.multiplyScalar(2.2 * Math.sin( (performance.now() * 0.006) + (index) ) ).multiplyScalar(0.01);
              return velocity;
          }
            
        })
    }

    update() {
        ctx.fillStyle = 'black';
        ctx.lineWidth =2
        this.qiNodes.forEach( (node, index) => node.update(index));
    }
}

class QiNode {
    constructor( position) {
        this.position = position;
        this.links = []
        this.velocity = () => {
            return new Vector2(0, 0);
        }
        this.acceleration = new Vector2(0, 0)

    }

    addLink (qiNode) {
        this.links.push(qiNode);

    }

    update(index){

        this.position.add(this.velocity());
        this.draw();
    }

    draw () {
        ctx.strokeStyle = "white";
        ctx.beginPath();
        ctx.arc(this.position.x, this.position.y, 10, 0, Math.PI * 2);
        ctx.fill();
        ctx.closePath();

        this.drawLinks();
    }



    drawLinks() {
        this.links.forEach( (link)=> {
            ctx.beginPath();
            ctx.moveTo(this.position.x, this.position.y);
            ctx.lineTo(link.position.x, link.position.y);
            ctx.stroke();
            ctx.closePath();
        } )
    }


}

export {QiBall}